import { DeliveryMethodChoiceType, type DeliveryMethodStateType } from './reducer';
import type { StateType } from '../../reducers';

const deliveryMethodStateSelector = (state: StateType): DeliveryMethodStateType | undefined =>
  state.signUp.deliveryMethod;

export const deliveryMethodSelector = (state: StateType): ?DeliveryMethodChoiceType => {
  const deliveryMethodState = deliveryMethodStateSelector(state);
  if (!deliveryMethodState) return null;

  const choices = deliveryMethodChoicesSelector(state);
  return choices.find(choice => choice.id === deliveryMethodState.selected);
};

export const simPriceSelector = (state: StateType): number | undefined => {
  const deliveryMethod = deliveryMethodSelector(state);
  return deliveryMethod ? deliveryMethod.price : undefined;
};

export const deliveryMethodChoicesSelector = (state: StateType): DeliveryMethodChoiceType[] => {
  const deliveryMethodState = deliveryMethodStateSelector(state);
  return deliveryMethodState ? deliveryMethodState.order.map(id => deliveryMethodState.choices[id]) : [];
};

export const canChooseDeliveryMethodSelector = (state: StateType): boolean => {
  const choices = deliveryMethodChoicesSelector(state);
  return choices.length > 1;
};
